const { getProductData, formatCurrency, } = await window.importScript(window.scriptUrls["helpers"]);
const { createApp, computed, ref, watch } = await window.importScript(window.scriptUrls["vue3-esm"]);
const ProductPrice = (await window.importScript(window.scriptUrls["vue3-product-price"]))?.default;



function mount(element) {
    const productHandle = element.dataset.productHandle;

    return createApp({
        delimiters: ['${','}'],
        components: {
            'product-price': ProductPrice,
        },
        setup() {
            const isLoading = ref(true);
            const product = ref(null);
            const selectedOptions = ref({ })
            const hasMultiVariants = computed(() => product.value?.options.length > 0 && product.value?.variants[0].option1 != 'Default Title' );

            watch(product, (newValue, oldValue ) => {
                if(newValue?.id != oldValue?.id) {
                    selectedOptions.value = { ...product.value.variants[0].options }
                }
            });

            const selectedVariant = computed(() => {
                var variant = product.value?.variants.find((variant) => {
                    return variant.options.reduce((output, option, key) => {
                        return typeof selectedOptions.value[key] != 'undefined' && option == selectedOptions.value[key] && output
                    }, true)
                })

                return variant
            })

            const groupedOptions = computed(() => {
                let optionsArr = { 0: [], 1: [], 2: [], };
                product.value?.variants.forEach((variant) => {
                    variant.options.forEach((option, index) => {
                        if (!optionsArr[index].includes(option)) {
                            optionsArr[index].push(option);
                        }
                    })
                })
                return optionsArr;
            })
            function optionIsAvailable(index, option) {

                // console.log(index, option, selectedOptions)

                let adjustedSelectedOptions = Object.assign([], selectedOptions.value)
                
                adjustedSelectedOptions[index] = option

                let output = product.value.variants.some((variant) => {
                    return variant.available && variant.options.reduce((output, option, key) => {
                        return typeof adjustedSelectedOptions[key] != 'undefined' && option == adjustedSelectedOptions[key] && output
                    }, true)
                })

                // console.log(output)

                return output
            }

            
            getProductData(productHandle).then(data => {
                console.log("Product data response", data)
                product.value = data.product;
                isLoading.value = false;

                console.log("groupedOptions", groupedOptions.value)
            });

            watch(isLoading, (newValue, oldValue) => {
                if (oldValue === true && newValue === false) {
                    console.log('Product loaded:', product.value);
                    element.dispatchEvent(new CustomEvent('vue3-product-options-loaded', {
                        detail: { product: product.value }
                    }));
                }
            });

            return {
                product,
                isLoading,
                hasMultiVariants,
                selectedOptions,
                selectedVariant,
                groupedOptions,

                // functions
                optionIsAvailable,
                formatCurrency,
            }
        }
    }).mount(element);
}

export default function app(selector) {
    const elements = Array.from(document.querySelectorAll(selector));

    elements.forEach(element => {
        mount(element);
    });
}

